import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./qr-code-modal.i18n";

type QRCodeModalProps = {
  open: boolean;
  onClose: () => void;
  url: string;
  title?: string;
  downloadFileName?: string;
};

export function QRCodeModal({
  open,
  onClose,
  url,
  title,
  downloadFileName = "qr-code",
}: QRCodeModalProps) {
  const t = useT(T);
  const effectiveTitle = title || t.qrCode;
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const handleDownload = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const pngUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = `${downloadFileName}.png`;
    link.href = pngUrl;
    link.click();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{effectiveTitle}</DialogTitle>
          <DialogDescription className="sr-only">{t.description}</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center py-4">
          <div className="bg-white p-4 rounded-lg">
            <QRCodeCanvas ref={canvasRef} value={url} size={256} level="M" />
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button data-dialog-guard-ignore variant="outline" onClick={handleDownload}>
            {t.downloadPng}
          </Button>
          <Button variant="outline" onClick={onClose}>
            {t.close}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
